// import React, { Component } from "react";
// import {
//   Button,
//   IconButton,
//   Tooltip,
//   TextField,
//   InputAdornment,
// } from "@material-ui/core";
// import { VpnKey, ExitToApp, Search } from "@material-ui/icons";
// import { GetCustomerDetails } from "../../../../services";
// import { NotificationManager } from "react-notifications";
// import SubEdit from "../edit";
// import swal from "sweetalert";

// export default class View extends Component {
//   constructor(props) {
//     super(props);
//     this.state = {
//       getList: [],
//       filteredList: [],
//       searchQuery: "",
//       customerId: "",
//       currentPage: 0,
//       totalRecords: 0,
//       limit: 1000,
//     };
//   }

//   handleBack() {
//     this.props.history.goBack();
//   }

//   async searchCustomers(query) {
//     try {
//       const response = await GetCustomerDetails.searchCustomers(query);
//       this.setState({ filteredList: response.customers });
//     } catch (error) {
//       NotificationManager.error("Failed to search customers", "Error");
//     }
//   }

//   handleTextSearch = (e) => {
//     this.setState({ searchQuery: e.target.value });
//   };

//   handleCustomerIdSearch = (e) => {
//     this.setState({ customerId: e.target.value });
//   };

//   handleSearchSubmit = async () => {
//     const { searchQuery, customerId } = this.state;

//     await this.searchCustomers({
//       query: searchQuery,
//       customerId,
//     });
//   };

//   async searchCustomers(payload) {
//     try {
//       const response = await GetCustomerDetails.searchCustomers(payload);
//       this.setState({ filteredList: response.customers });
//     } catch (error) {
//       NotificationManager.error("Failed to search customers", "Error");
//     }
//   }

//   handleLoginAsUser = async (userId) => {
//     try {
//       const data = { userId };
//       // Make the API request to log in as the user
//       const response = await GetCustomerDetails.getAdminUserLogin(data);

//       // Check if the response indicates a successful login
//       if (response.data.success && response.data.token && response.data.user) {
//         const { token, user } = response.data;

//         // Open the new tab with the URL, passing the token as a query parameter
//         window.open(
//           `https://jc-creations.co.in/?token=${token}&email=${user.email}`,
//           "_blank",
//         );
//       } else {
//         NotificationManager.error("Failed to login as user", "Error");
//       }
//     } catch (error) {
//       console.error("Error logging in as user:", error);
//       NotificationManager.error(
//         "An error occurred while logging in as user",
//         "Error",
//       );
//     }
//   };

//   async handleDeleteById(id) {
//     swal({
//       title: "Are you sure?",
//       text: "You want to delete Customer from the List",
//       icon: "warning",
//       buttons: true,
//       dangerMode: true,
//     }).then(async (success) => {
//       if (success) {
//         let value = await GetCustomerDetails.getCustomerDeleteById(id);
//         if (value) {
//           NotificationManager.success(value.msg, "Status");
//           setTimeout(async () => {
//             this.searchCustomers(this.state.searchQuery);
//           }, 1000);
//         }
//       }
//     });
//   }

//   async handleResetPassword(email, phone) {
//     swal({
//       title: "Are you sure?",
//       text: "You want to reset the password for this customer?",
//       icon: "warning",
//       buttons: true,
//       dangerMode: true,
//     }).then(async (success) => {
//       if (success) {
//         let response = await GetCustomerDetails.resetPassword(email, phone);
//         if (response && response.success) {
//           NotificationManager.success("Password reset successfully", "Status");
//         } else {
//           NotificationManager.error("Failed to reset password", "Error");
//         }
//       }
//     });
//   }

//   handleNextPage = () => {
//     const { currentPage } = this.state;
//     this.getCustomer(currentPage + 1);
//   };

//   handlePreviousPage = () => {
//     const { currentPage } = this.state;
//     if (currentPage > 0) {
//       this.getCustomer(currentPage - 1);
//     }
//   };

//   render() {
//     const { filteredList, searchQuery, currentPage, totalRecords, limit } =
//       this.state;
//     const totalPages = Math.ceil(totalRecords / limit);

//     return (
//       <div className="container-fluid">
//         <div className="row">
//           <div className="col-lg-5 col-md-9 col-lg-6">
//             <h2 className="mt-30 page-title">Customer</h2>
//           </div>
//           <div className="col-lg-5 col-md-3 col-lg-6 back-btn">
//             <Button variant="contained" onClick={() => this.handleBack()}>
//               <i className="fas fa-arrow-left" /> Back
//             </Button>
//           </div>
//         </div>
//         <ol className="breadcrumb mb-30">
//           <li className="breadcrumb-item">
//             <a href="index.html">Dashboard</a>
//           </li>
//           <li className="breadcrumb-item active">Customer</li>
//         </ol>
//         <div className="row justify-content-between">
//           <div className="col-lg-5 col-md-6">
//             <div className="bulk-section mt-30">
//               <div style={{ maxWidth: "420px" }}>
//                 {/* Customer ID */}
//                 <TextField
//                   variant="outlined"
//                   placeholder="Search by Customer ID"
//                   value={this.state.customerId}
//                   onChange={this.handleCustomerIdSearch}
//                   fullWidth
//                   margin="normal"
//                   InputProps={{
//                     style: { height: 46 },
//                   }}
//                 />

//                 {/* Name / Phone / Email */}
//                 <TextField
//                   variant="outlined"
//                   placeholder="Search by Name / Phone / Email"
//                   value={this.state.searchQuery}
//                   onChange={this.handleTextSearch}
//                   fullWidth
//                   margin="normal"
//                   InputProps={{
//                     startAdornment: (
//                       <InputAdornment position="start">
//                         <Search style={{ color: "gray" }} />
//                       </InputAdornment>
//                     ),
//                     style: { height: 46 },
//                   }}
//                 />

//                 {/* Search Button */}
//                 <Button
//                   variant="contained"
//                   color="primary"
//                   fullWidth
//                   style={{ height: 46, marginTop: 12 }}
//                   onClick={this.handleSearchSubmit}
//                 >
//                   Search
//                 </Button>
//               </div>
//             </div>
//           </div>
//           <div className="col-lg-12 col-md-12">
//             {filteredList.length > 0 ? (
//               <div className="card card-static-2 mt-30 mb-30">
//                 <div className="card-title-2">
//                   <h4>All Customers</h4>
//                 </div>
//                 <div className="card-body-table">
//                   <div className="table-responsive">
//                     <table className="table ucp-table table-hover">
//                       <thead>
//                         <tr>
//                           <th style={{ width: 60 }}>
//                             <input type="checkbox" className="check-all" />
//                           </th>
//                           <th style={{ width: 60 }}>ID</th>
//                           <th>Full Name</th>
//                           <th>Phone</th>
//                           <th>Email</th>
//                           <th>Offer</th>
//                           <th>Status</th>
//                           <th>Action</th>
//                         </tr>
//                       </thead>
//                       <tbody>
//                         {filteredList.map((row, index) => (
//                           <tr key={row.id}>
//                             <td>
//                               <input
//                                 type="checkbox"
//                                 className="check-item"
//                                 name="ids[]"
//                                 value={row.id}
//                               />
//                             </td>
//                             <td>{row.id}</td>
//                             <td>{row.fullName}</td>
//                             <td>{row.phone}</td>
//                             <td>{row.email}</td>

//                             <td>
//                               {row.offer === "Not Claimed" ? (
//                                 <span
//                                   style={{
//                                     color: "orange",
//                                     fontWeight: "bold",
//                                   }}
//                                 >
//                                   Not Claimed
//                                 </span>
//                               ) : (
//                                 <span
//                                   style={{ color: "blue", fontWeight: "bold" }}
//                                 >
//                                   Claimed
//                                 </span>
//                               )}
//                             </td>

//                             <td>
//                               {row.gender === "active" ? (
//                                 <span
//                                   style={{ color: "green", fontWeight: "bold" }}
//                                 >
//                                   Active
//                                 </span>
//                               ) : (
//                                 <span
//                                   style={{ color: "red", fontWeight: "bold" }}
//                                 >
//                                   Inactive
//                                 </span>
//                               )}
//                             </td>
//                             <td className="action-btns">
//                               <SubEdit
//                                 state={row}
//                                 onUpdate={() =>
//                                   this.searchCustomers(this.state.searchQuery)
//                                 }
//                               />

//                               <Tooltip title="Reset Password">
//                                 <IconButton
//                                   color="secondary"
//                                   size="small"
//                                   onClick={() =>
//                                     this.handleResetPassword(
//                                       row.email,
//                                       row.phone,
//                                     )
//                                   }
//                                 >
//                                   <VpnKey />
//                                 </IconButton>
//                               </Tooltip>

//                               <Tooltip title="Login as User">
//                                 <IconButton
//                                   color="primary"
//                                   size="small"
//                                   onClick={() => this.handleLoginAsUser(row.id)}
//                                 >
//                                   <ExitToApp />
//                                 </IconButton>
//                               </Tooltip>
//                             </td>
//                           </tr>
//                         ))}
//                       </tbody>
//                     </table>
//                   </div>
//                 </div>
//                 <div
//                   className="pagination"
//                   style={{
//                     display: "flex",
//                     alignItems: "center",
//                     justifyContent: "center",
//                     gap: "15px",
//                     marginTop: "20px",
//                   }}
//                 >
//                   <Button
//                     variant="contained"
//                     color="primary"
//                     onClick={this.handlePreviousPage}
//                     disabled={currentPage === 0 || totalPages <= 1}
//                   >
//                     Previous
//                   </Button>

//                   <span style={{ fontWeight: "bold", fontSize: "15px" }}>
//                     {totalPages <= 0
//                       ? "No pages"
//                       : totalPages === 1
//                         ? "Page 1"
//                         : `Page ${currentPage + 1} of ${totalPages}`}
//                   </span>

//                   <Button
//                     variant="contained"
//                     color="primary"
//                     onClick={this.handleNextPage}
//                     disabled={currentPage >= totalPages - 1 || totalPages <= 1}
//                   >
//                     Next
//                   </Button>
//                 </div>
//               </div>
//             ) : (
//               <div className="mt-30">
//                 No customers to display. Please search to view results.
//               </div>
//             )}
//           </div>
//         </div>
//       </div>
//     );
//   }
// }


import React, { Component } from "react";
import {
  Button,
  IconButton,
  Tooltip,
  TextField,
  InputAdornment,
} from "@material-ui/core";
import {
  VpnKey,
  ExitToApp,
  Search,
} from "@material-ui/icons";
import { GetCustomerDetails } from "../../../../services";
import { NotificationManager } from "react-notifications";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import SubEdit from "../edit";
import swal from "sweetalert";

export default class View extends Component {
  constructor(props) {
    super(props);

    this.state = {
      getList: [],
      filteredList: [],
      searchQuery: "",
      customerId: "",
      currentPage: 0,
      totalRecords: 0,
      limit: 1000,
    };
  }

  handleBack = () => {
    this.props.history.goBack();
  };

  /**
   * Search customers
   */
  searchCustomers = async (payload) => {
    try {
      const searchPayload = {
        query:
          payload && payload.query
            ? payload.query
            : "",
        customerId:
          payload && payload.customerId
            ? payload.customerId
            : "",
      };

      const response =
        await GetCustomerDetails.searchAllCustomers(
          searchPayload
        );

      const customers =
        response &&
        Array.isArray(response.customers)
          ? response.customers
          : [];

      this.setState({
        filteredList: customers,
        currentPage: 0,
        totalRecords:
          response &&
          response.totalRecords
            ? response.totalRecords
            : customers.length,
      });
    } catch (error) {
      console.error(
        "Search customers error:",
        error
      );

      NotificationManager.error(
        "Failed to search customers",
        "Error"
      );

      this.setState({
        filteredList: [],
        totalRecords: 0,
      });
    }
  };

  /**
   * Search button
   */
  handleSearchSubmit = () => {
    this.searchCustomers({
      query: this.state.searchQuery,
      customerId: this.state.customerId,
    });
  };

  /**
   * Search text
   */
  handleTextSearch = (e) => {
    this.setState({
      searchQuery: e.target.value,
    });
  };

  /**
   * Customer ID search
   */
  handleCustomerIdSearch = (e) => {
    this.setState({
      customerId: e.target.value,
    });
  };

  /**
   * Called after customer is successfully edited
   *
   * Updates only the edited row.
   * No API request is required here.
   */
  handleCustomerUpdated = (updatedCustomer) => {
    if (!updatedCustomer) {
      return;
    }

    this.setState((prevState) => {
      const updatedList =
        prevState.filteredList.map(
          (customer) => {
            if (
              String(customer.id) ===
              String(updatedCustomer.id)
            ) {
              return {
                ...customer,
                ...updatedCustomer,
              };
            }

            return customer;
          }
        );

      return {
        filteredList: updatedList,
      };
    });

    NotificationManager.success(
      "Customer updated successfully",
      "Status"
    );
  };

  /**
   * Login as customer
   */
  handleLoginAsUser = async (userId) => {
    try {
      const data = {
        userId,
      };

      const response =
        await GetCustomerDetails.getAdminUserLogin(
          data
        );

      if (
        response &&
        response.data &&
        response.data.success &&
        response.data.token &&
        response.data.user
      ) {
        const {
          token,
          user,
        } = response.data;

        window.open(
          `https://jc-creations.co.in/?token=${token}&email=${user.email}`,
          "_blank"
        );
      } else {
        NotificationManager.error(
          "Failed to login as user",
          "Error"
        );
      }
    } catch (error) {
      console.error(
        "Error logging in as user:",
        error
      );

      NotificationManager.error(
        "An error occurred while logging in as user",
        "Error"
      );
    }
  };

  /**
   * Delete customer
   */
  handleDeleteById = async (id) => {
    swal({
      title: "Are you sure?",
      text:
        "You want to delete Customer from the List",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    }).then(async (success) => {
      if (!success) {
        return;
      }

      try {
        const value =
          await GetCustomerDetails.getCustomerDeleteById(
            id
          );

        if (value) {
          NotificationManager.success(
            value.msg,
            "Status"
          );

          this.searchCustomers({
            query: this.state.searchQuery,
            customerId: this.state.customerId,
          });
        }
      } catch (error) {
        console.error(
          "Delete customer error:",
          error
        );

        NotificationManager.error(
          "Failed to delete customer",
          "Error"
        );
      }
    });
  };

  /**
   * Reset password
   */
  handleResetPassword = async (
    email,
    phone
  ) => {
    swal({
      title: "Are you sure?",
      text:
        "You want to reset the password for this customer?",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    }).then(async (success) => {
      if (!success) {
        return;
      }

      try {
        const response =
          await GetCustomerDetails.resetPassword(
            email,
            phone
          );

        if (
          response &&
          response.success
        ) {
          NotificationManager.success(
            "Password reset successfully",
            "Status"
          );
        } else {
          NotificationManager.error(
            "Failed to reset password",
            "Error"
          );
        }
      } catch (error) {
        console.error(
          "Reset password error:",
          error
        );

        NotificationManager.error(
          "Failed to reset password",
          "Error"
        );
      }
    });
  };

  /**
   * Pagination
   *
   * Your current API implementation does not
   * contain getCustomer(), so do not call it here.
   *
   * If you want server-side pagination, we can
   * connect this to the API separately.
   */
  handleNextPage = () => {
    console.log(
      "Pagination API is not connected yet."
    );
  };

  handlePreviousPage = () => {
    console.log(
      "Pagination API is not connected yet."
    );
  };

  render() {
    const {
      filteredList,
      currentPage,
      totalRecords,
      limit,
    } = this.state;

    const totalPages =
      Math.ceil(
        totalRecords / limit
      );

    return (
      <div>
        <ToastContainer
          position="top-right"
          autoClose={3000}
          hideProgressBar={false}
          newestOnTop={true}
          closeOnClick={true}
          pauseOnFocusLoss={false}
          draggable={true}
          pauseOnHover={false}
        />

        <div className="container-fluid">
          <div className="row">
            <div className="col-lg-6 col-md-9">
              <h2 className="mt-30 page-title">
                Customer
              </h2>
            </div>

            <div className="col-lg-6 col-md-3 back-btn">
              <Button
                variant="contained"
                onClick={
                  this.handleBack
                }
              >
                <i className="fas fa-arrow-left" />
                {" "}
                Back
              </Button>
            </div>
          </div>

          <ol className="breadcrumb mb-30">
            <li className="breadcrumb-item">
              <a href="index.html">
                Dashboard
              </a>
            </li>

            <li className="breadcrumb-item active">
              Customer
            </li>
          </ol>

          <div className="row justify-content-between">
            <div className="col-lg-5 col-md-6">
              <div className="bulk-section mt-30">
                <div
                  style={{
                    maxWidth: "420px",
                  }}
                >
                  {/* Customer ID */}
                  <TextField
                    variant="outlined"
                    placeholder="Search by Customer ID"
                    value={
                      this.state.customerId
                    }
                    onChange={
                      this.handleCustomerIdSearch
                    }
                    fullWidth
                    margin="normal"
                    InputProps={{
                      style: {
                        height: 46,
                      },
                    }}
                  />

                  {/* Name / Phone / Email */}
                  <TextField
                    variant="outlined"
                    placeholder="Search by Name / Phone / Email"
                    value={
                      this.state.searchQuery
                    }
                    onChange={
                      this.handleTextSearch
                    }
                    fullWidth
                    margin="normal"
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <Search
                            style={{
                              color: "gray",
                            }}
                          />
                        </InputAdornment>
                      ),
                      style: {
                        height: 46,
                      },
                    }}
                  />

                  {/* Search */}
                  <Button
                    variant="contained"
                    color="primary"
                    fullWidth
                    style={{
                      height: 46,
                      marginTop: 12,
                    }}
                    onClick={
                      this.handleSearchSubmit
                    }
                  >
                    Search
                  </Button>
                </div>
              </div>
            </div>

            <div className="col-lg-12 col-md-12">
              {filteredList.length > 0 ? (
                <div className="card card-static-2 mt-30 mb-30">
                  <div className="card-title-2">
                    <h4>
                      All Customers
                    </h4>
                  </div>

                  <div className="card-body-table">
                    <div className="table-responsive">
                      <table className="table ucp-table table-hover">
                        <thead>
                          <tr>
                            <th
                              style={{
                                width: 60,
                              }}
                            >
                              <input
                                type="checkbox"
                                className="check-all"
                              />
                            </th>

                            <th
                              style={{
                                width: 60,
                              }}
                            >
                              ID
                            </th>

                            <th>
                              Full Name
                            </th>

                            <th>
                              Phone
                            </th>

                            <th>
                              Email
                            </th>

                            <th>
                              Offer
                            </th>

                            <th>
                              Status
                            </th>

                            <th>
                              Action
                            </th>
                          </tr>
                        </thead>

                        <tbody>
                          {filteredList.map(
                            (row) => (
                              <tr
                                key={
                                  row.id
                                }
                              >
                                <td>
                                  <input
                                    type="checkbox"
                                    className="check-item"
                                    name="ids[]"
                                    value={
                                      row.id
                                    }
                                  />
                                </td>

                                <td>
                                  {row.id}
                                </td>

                                <td>
                                  {
                                    row.fullName
                                  }
                                </td>

                                <td>
                                  {
                                    row.phone
                                  }
                                </td>

                                <td>
                                  {
                                    row.email
                                  }
                                </td>

                                <td>
                                  {row.offer ===
                                  "Not Claimed" ? (
                                    <span
                                      style={{
                                        color:
                                          "orange",
                                        fontWeight:
                                          "bold",
                                      }}
                                    >
                                      Not Claimed
                                    </span>
                                  ) : (
                                    <span
                                      style={{
                                        color:
                                          "blue",
                                        fontWeight:
                                          "bold",
                                      }}
                                    >
                                      Claimed
                                    </span>
                                  )}
                                </td>

                                <td>
                                  {row.gender ===
                                  "active" ? (
                                    <span
                                      style={{
                                        color:
                                          "green",
                                        fontWeight:
                                          "bold",
                                      }}
                                    >
                                      Active
                                    </span>
                                  ) : (
                                    <span
                                      style={{
                                        color:
                                          "red",
                                        fontWeight:
                                          "bold",
                                      }}
                                    >
                                      Inactive
                                    </span>
                                  )}
                                </td>

                                <td className="action-btns">
                                  <SubEdit
                                    state={
                                      row
                                    }
                                    onUpdate={
                                      this
                                        .handleCustomerUpdated
                                    }
                                  />

                                  <Tooltip title="Reset Password">
                                    <IconButton
                                      color="secondary"
                                      size="small"
                                      onClick={() =>
                                        this.handleResetPassword(
                                          row.email,
                                          row.phone
                                        )
                                      }
                                    >
                                      <VpnKey />
                                    </IconButton>
                                  </Tooltip>

                                  <Tooltip title="Login as User">
                                    <IconButton
                                      color="primary"
                                      size="small"
                                      onClick={() =>
                                        this.handleLoginAsUser(
                                          row.id
                                        )
                                      }
                                    >
                                      <ExitToApp />
                                    </IconButton>
                                  </Tooltip>
                                </td>
                              </tr>
                            )
                          )}
                        </tbody>
                      </table>
                    </div>
                  </div>

                  <div
                    className="pagination"
                    style={{
                      display: "flex",
                      alignItems:
                        "center",
                      justifyContent:
                        "center",
                      gap: "15px",
                      marginTop:
                        "20px",
                    }}
                  >
                    <Button
                      variant="contained"
                      color="primary"
                      onClick={
                        this
                          .handlePreviousPage
                      }
                      disabled={
                        currentPage ===
                          0 ||
                        totalPages <=
                          1
                      }
                    >
                      Previous
                    </Button>

                    <span
                      style={{
                        fontWeight:
                          "bold",
                        fontSize:
                          "15px",
                      }}
                    >
                      {totalPages <=
                      0
                        ? "No pages"
                        : totalPages ===
                          1
                        ? "Page 1"
                        : `Page ${
                            currentPage +
                            1
                          } of ${
                            totalPages
                          }`}
                    </span>

                    <Button
                      variant="contained"
                      color="primary"
                      onClick={
                        this
                          .handleNextPage
                      }
                      disabled={
                        currentPage >=
                          totalPages -
                            1 ||
                        totalPages <=
                          1
                      }
                    >
                      Next
                    </Button>
                  </div>
                </div>
              ) : (
                <div className="mt-30">
                  No customers to
                  display. Please
                  search to view
                  results.
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    );
  }
}




// WEBPACK FOOTER //
// ./src/components/admin/view/customer/view/index.js